import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  dailyjournal: localStorage.getItem('dailyjournal')
    ? JSON.parse(localStorage.getItem('dailyjournal'))
    : null,
};

const dailyjournalSlice = createSlice({
  name: 'dailyjournal',
  initialState,
  reducers: {
    setDailyjournal: (state, action) => {
      state.dailyjournal = action.payload;
      localStorage.setItem('dailyjournal', JSON.stringify(action.payload));
    },
  },
});

export const {setDailyjournal } = dailyjournalSlice.actions;

export default dailyjournalSlice.reducer;
